import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'
import { PaymentType } from '../../enums/payment-type.enum'

export const createIncomeSchema = z.object({
  amount: z.number().positive(),
  currency: z.nativeEnum(Currency),
  description: z.string().max(500).optional(),
  date: z
    .string()
    .datetime({ offset: true })
    .optional()
    .default(() => new Date().toISOString()),
  paymentType: z.nativeEnum(PaymentType).optional(),
  accountId: z.string().guid(),
  categoryId: z.string().guid(),
  spentAmount: z.number().positive().optional(),
  conversionRate: z.number().positive().optional(),
})

export type CreateIncomeDto = z.infer<typeof createIncomeSchema>
